import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSafeIntl, commonStyles } from 'bluesquare-components';
import TopBar from '../../components/nav/TopBarComponent';
import { baseUrls } from '../../constants/urls';
import { useParamsObject } from '../../routing/hooks/useParamsObject';
import { Filters } from './components/Filters';
import { FormsTable } from './components/FormsTable';
import { useGetForms } from './hooks/useGetForms';
import MESSAGES from './messages';
import { FormsParams } from './types/forms';

const useStyles = makeStyles(theme => ({ ...commonStyles(theme) }));

const Forms: FunctionComponent = () => {
    const baseUrl = baseUrls.forms;
    const params = useParamsObject(baseUrl) as unknown as FormsParams;
    const classes = useStyles();
    const { formatMessage } = useSafeIntl();

    // This doesn't duplicate API calls as long as
    // the querystring generated by useGetForms is the same as the one in the table
    const { data: forms, isLoading: isLoadingForms } = useGetForms(
        params,
        undefined,
        true,
    );

    return (
        <>
            <TopBar title={formatMessage(MESSAGES.title)} />
            <Box className={classes.containerFullHeightNoTabPadded}>
                <Filters
                    params={params}
                    forms={forms}
                    isLoadingForms={isLoadingForms}
                />
                <FormsTable baseUrl={baseUrl} params={params} />
            </Box>
        </>
    );
};

export default Forms;
